import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteFileApi,
  deleteStoriesApi,
  deleteStroyCategoryApi,
  getSroriesApi,
  getStroyCategoryApi,
  pauseStoriesApi,
  postSroryApi,
  postStroyCategoryApi,
  updateStoriesApi,
  updateStroyCategoryApi,
  uploadFileApi,
} from "../api/StoryApi";

const initialState = {
  stories: [],
  storyCategory: [],
  rhymeCategory: [],
  groupByCategory: "",
  groupByLanguage: "",
  language: "",
  storyFilter: false,
  rhymeFilter: false,

  editStory: {
    isEdit: false,
    body: {},
  },

  editCategory: {
    isEdit: false,
    body: {},
  },

  isAudio: false,

  loading: false,
  uploading: false,
  posting: false,
  deleting: false,
  catposting: false,
};

export const postSrory = createAsyncThunk(
  "story/postSrory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postSroryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getSrories = createAsyncThunk(
  "story/getSrories",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSroriesApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateStories = createAsyncThunk(
  "story/updateStories",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateStoriesApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteStories = createAsyncThunk(
  "story/deleteStories",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteStoriesApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const pauseStories = createAsyncThunk(
  "story/pauseStories",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await pauseStoriesApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getStoryCategory = createAsyncThunk(
  "story/getStoryCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getStroyCategoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);
export const postStoryCategory = createAsyncThunk(
  "story/postStoryCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postStroyCategoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);
export const updateStoryCategory = createAsyncThunk(
  "story/updateStoryCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateStroyCategoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);
export const deleteStoryCategory = createAsyncThunk(
  "story/deleteStoryCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteStroyCategoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const uploadFile = createAsyncThunk(
  "story/uploadFile",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("File upload slice", payload);
      const response = await uploadFileApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteFile = createAsyncThunk(
  "story/deleteFile",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("File upload slice", payload);
      const response = await deleteFileApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

const storySlice = createSlice({
  name: "story",
  initialState,
  reducers: {
    addStoryFilter: (state, action) => {
      state.storyFilter = action.payload;
      state.rhymeFilter = false;
    },
    addRhymeFilter: (state, action) => {
      state.rhymeFilter = action.payload;
      state.storyFilter = false;
    },
    addCategoryGroup: (state, action) => {
      state.groupByCategory = action.payload;
    },
    addLanguageGroup: (state, action) => {
      state.groupByLanguage = action.payload;
    },
    addLanguage: (state, action) => {
      state.language = action.payload;
    },
    setIsAudio: (state, action) => {
      state.isAudio = action.payload;
    },
    setEditStory: (state, action) => {
      state.editStory = {
        isEdit: action.payload.isEdit,
        body: action.payload.body,
      };
    },
    setEditCategory: (state, action) => {
      state.editCategory = {
        isEdit: action.payload.isEdit,
        body: action.payload.body,
      };
    },
    clearFilter: (state, action) => {
      state.storyFilter = false;
      state.rhymeFilter = false;
    },
  },
  extraReducers: (builder) => {
    // post story
    builder.addCase(postSrory.pending, (state) => {
      state.posting = true;
    });
    builder.addCase(postSrory.fulfilled, (state, action) => {
      //   state.filters = action.payload?.response;
      state.posting = false;
    });
    builder.addCase(postSrory.rejected, (state) => {
      state.posting = false;
    });

    // update story
    builder.addCase(updateStories.pending, (state) => {
      state.posting = true;
    });
    builder.addCase(updateStories.fulfilled, (state, action) => {
      //   state.filters = action.payload?.response;
      state.posting = false;
    });
    builder.addCase(updateStories.rejected, (state) => {
      state.posting = false;
    });

    // update story
    builder.addCase(deleteStories.pending, (state) => {
      state.deleting = true;
    });
    builder.addCase(deleteStories.fulfilled, (state, action) => {
      //   state.filters = action.payload?.response;
      state.deleting = false;
    });
    builder.addCase(deleteStories.rejected, (state) => {
      state.deleting = false;
    });

    // update story
    builder.addCase(pauseStories.pending, (state) => {
      state.posting = true;
    });
    builder.addCase(pauseStories.fulfilled, (state, action) => {
      //   state.filters = action.payload?.response;
      state.posting = false;
    });
    builder.addCase(pauseStories.rejected, (state) => {
      state.posting = false;
    });

    // get story
    builder.addCase(getSrories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSrories.fulfilled, (state, action) => {
      console.log("stories slice", action.payload.response);
      state.stories = action.payload.response;
      state.loading = false;
    });
    builder.addCase(getSrories.rejected, (state) => {
      state.loading = false;
    });

    // get story category
    builder.addCase(getStoryCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStoryCategory.fulfilled, (state, action) => {
      state.storyCategory = action.payload.response?.storyCategories || [];
      state.rhymeCategory = action.payload.response?.rhymeCategory || [];
      state.loading = false;
    });
    builder.addCase(getStoryCategory.rejected, (state) => {
      state.loading = false;
    });

    // post story category
    builder.addCase(postStoryCategory.pending, (state) => {
      state.catposting = true;
    });
    builder.addCase(postStoryCategory.fulfilled, (state, action) => {
      state.catposting = false;
    });
    builder.addCase(postStoryCategory.rejected, (state) => {
      state.catposting = false;
    });

    // update story category
    builder.addCase(updateStoryCategory.pending, (state) => {
      state.catposting = true;
    });
    builder.addCase(updateStoryCategory.fulfilled, (state, action) => {
      state.catposting = false;
    });
    builder.addCase(updateStoryCategory.rejected, (state) => {
      state.catposting = false;
    });

    // delete story category
    builder.addCase(deleteStoryCategory.pending, (state) => {
      state.catposting = true;
    });
    builder.addCase(deleteStoryCategory.fulfilled, (state, action) => {
      state.catposting = false;
    });
    builder.addCase(deleteStoryCategory.rejected, (state) => {
      state.catposting = false;
    });

    // upload file
    builder.addCase(uploadFile.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(uploadFile.fulfilled, (state, action) => {
      //   state.filters = action.payload?.response;
      state.uploading = false;
      state.isAudio = false;
    });
    builder.addCase(uploadFile.rejected, (state) => {
      state.uploading = false;
    });

    // delete file
    builder.addCase(deleteFile.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(deleteFile.fulfilled, (state, action) => {
      //   state.filters = action.payload?.response;
      state.uploading = false;
      state.isAudio = false;
    });
    builder.addCase(deleteFile.rejected, (state) => {
      state.uploading = false;
    });
  },
});

export const {
  addCategoryGroup,
  addLanguage,
  addLanguageGroup,
  setIsAudio,
  setEditStory,
  setEditCategory,
  addRhymeFilter,
  addStoryFilter,
  clearFilter,
} = storySlice.actions;
export default storySlice.reducer;
